import qs from 'query-string';
import useSWRImmutable from 'swr/immutable';
import { createHttpAction } from '../api';
import { Service } from '../enums';
import { CUSTOMER_MOCK } from '../mocks';
import { getCustomerFromToken } from '../utils/auth';
import { getMainCustomer } from '../utils/customer/mainCustomer';
export const useMainCustomer = ({ customerId, embed = ['all-persons', 'reference-accounts'], }) => {
    var _a;
    const bacNumber = customerId || ((_a = getCustomerFromToken()) === null || _a === void 0 ? void 0 : _a.bacNumber);
    const request = {
        service: Service.CAS,
        url: '/customers/:bacNumber',
        settings: {
            params: { embed },
            pathParams: { bacNumber },
            paramsSerializer: qs.stringify,
        },
    };
    const fetcher = () => createHttpAction(request, { data: CUSTOMER_MOCK });
    const requestUrl = bacNumber ? `${request === null || request === void 0 ? void 0 : request.url}${bacNumber}` : null;
    const { data, error, isLoading: customerLoading, mutate, isValidating, } = useSWRImmutable(requestUrl, fetcher);
    return {
        customerData: data === null || data === void 0 ? void 0 : data.data,
        mainCustomer: (data === null || data === void 0 ? void 0 : data.data) ? getMainCustomer({ customer: data === null || data === void 0 ? void 0 : data.data }) : undefined,
        loading: customerLoading,
        error: error,
        mutate: bacNumber ? mutate : undefined,
        isValidating,
    };
};
//# sourceMappingURL=useMainCustomer.js.map